<template>
  <div
    v-if="btnConfig.show"
    class="btn-area"
    :class="[
      btnConfig.setting.effectType,
      { 'default': !btnConfig.setting.image },
    ]"
    :style="themeStyle"
  >
    <a
      v-if="btnConfig.setting.url"
      class="image-btn btn-link"
      @click="redirectLink(btnConfig.setting.url)"
    >
      <picture v-if="btnConfig.setting.effectType.includes('images') && btnConfig.setting.hoverImage">
        <source
          :srcset="`${baseUrl}${webpImage(btnConfig.setting.hoverImage)}`"
          type="image/webp"
        >
        <b-img-lazy
          :src="`${baseUrl}${btnConfig.setting.hoverImage}`"
          :alt="btnConfig.setting.alt"
          class="hover-image"
          @click="redirectLink(btnConfig.setting.url)"
        />
      </picture>
      <div class="position-relative">
        <picture v-if="btnConfig.setting.image">
          <source
            :srcset="`${baseUrl}${webpImage(btnConfig.setting.image)}`"
            type="image/webp"
          >
          <b-img-lazy
            :src="`${baseUrl}${btnConfig.setting.image}`"
            :alt="btnConfig.setting.alt"
            :style="{ 'padding' : btnConfig.setting.imageSpacing }"
            class="normal-image"
            @click="redirectLink(btnConfig.setting.url)"
          />
        </picture>
        <picture v-if="btnConfig.setting.effectType.includes('zoom') && btnConfig.setting.decoImage">
          <source
            :srcset="`${baseUrl}${webpImage(btnConfig.setting.decoImage)}`"
            type="image/webp"
          >
          <b-img-lazy
            :src="`${baseUrl}${btnConfig.setting.decoImage}`"
            :alt="btnConfig.setting.alt"
            :style="{ 'padding' : btnConfig.setting.imageSpacing }"
            class="decoImage"
            @click="redirectLink(btnConfig.setting.url)"
          />
        </picture>
        <picture v-if="btnConfig.setting.effectType.includes('zoom') && btnConfig.setting.decoImage">
          <source
            :srcset="`${baseUrl}${webpImage(btnConfig.setting.decoImage)}`"
            type="image/webp"
          >
          <b-img-lazy
            :src="`${baseUrl}${btnConfig.setting.decoImage}`"
            :alt="btnConfig.setting.alt"
            :style="{ 'padding' : btnConfig.setting.imageSpacing }"
            class="decoImage decoImage-hover"
            @click="redirectLink(btnConfig.setting.url)"
          />
        </picture>
      </div>
    </a>
    <div
      v-else
      class="image-btn"
    >
      <picture v-if="btnConfig.setting.effectType.includes('images') && btnConfig.setting.hoverImage">
        <source
          :srcset="`${baseUrl}${webpImage(btnConfig.setting.hoverImage)}`"
          type="image/webp"
        >
        <b-img-lazy
          :src="`${baseUrl}${btnConfig.setting.hoverImage}`"
          :alt="btnConfig.setting.alt"
          :style="{ 'padding' : btnConfig.setting.imageSpacing }"
          class="hover-image"
          @click="redirectLink(btnConfig.setting.url)"
        />
      </picture>
      <div class="position-relative">
        <picture v-if="btnConfig.setting.image">
          <source
            :srcset="`${baseUrl}${webpImage(btnConfig.setting.image)}`"
            type="image/webp"
          >
          <b-img-lazy
            :src="`${baseUrl}${btnConfig.setting.image}`"
            :alt="btnConfig.setting.alt"
            :style="{ 'padding' : btnConfig.setting.imageSpacing }"
            class="normal-image"
            @click="redirectLink(btnConfig.setting.url)"
          />
        </picture>
        <picture v-if="btnConfig.setting.effectType.includes('zoom') && btnConfig.setting.decoImage">
          <source
            :srcset="`${baseUrl}${webpImage(btnConfig.setting.decoImage)}`"
            type="image/webp"
          >
          <b-img-lazy
            v-if="btnConfig.setting.decoImage"
            :src="`${baseUrl}${btnConfig.setting.decoImage}`"
            :alt="btnConfig.setting.alt"
            :style="{ 'padding' : btnConfig.setting.imageSpacing }"
            class="decoImage"
            @click="redirectLink(btnConfig.setting.url)"
          />
        </picture>
        <picture v-if="btnConfig.setting.effectType.includes('zoom') && btnConfig.setting.decoImage">
          <source
            :srcset="`${baseUrl}${webpImage(btnConfig.setting.decoImage)}`"
            type="image/webp"
          >
          <b-img-lazy
            v-if="btnConfig.setting.decoImage"
            :src="`${baseUrl}${btnConfig.setting.decoImage}`"
            :alt="btnConfig.setting.alt"
            :style="{ 'padding' : btnConfig.setting.imageSpacing }"
            class="decoImage decoImage-hover"
            @click="redirectLink(btnConfig.setting.url)"
          />
        </picture>
      </div>
      <div
        v-if="btnConfig.setting.useTitle"
        class="text-area"
        :style="btnConfig.color"
      >
        {{ btnConfig.setting.title }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  BImgLazy,
  // BImg,
} from 'bootstrap-vue'
// import VueLoadImage from 'vue-load-image'

export default {
  components: {
    // BImg,
    BImgLazy,
    // VueLoadImage,
  },
  props: {
    btnConfig: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      themeStyle: null,
    }
  },
  computed: {
    baseUrl() {
      return this.$store.state.api.baseUrl
    },
  },
  mounted() {
    this.themeStyle = this.btnConfig.color
  },
  methods: {
    // (網頁)跳轉
    redirectLink(link) {
      if (!link) return
      window.location.assign(link)
    },
    webpImage(src) {
      if (!src) return ''
      const webpSrc = src.replace(/\.[^.]+$/, '.webp')
      // const webpSrc = `${src.split('.')[0]}.webp`
      return webpSrc
    },
  },
}
</script>

<style lang="scss" scoped>
// $image: var(--image);
// $hover-image: var(--hover-image);
$shadow-color: var(--shadow-color);
$shadow-inset-color: var(--shadow-inset-color);
$image-brightness: var(--images-brightness);
.webp .btn-area.default {
  background-image: url('~@/assets/images/items/image.webp');
    &:hover.images{
      background-image: url('~@/assets/images/items/hoverImage.webp');
    }
}
.no-webp .btn-area.default {
  background-image: url('~@/assets/images/items/image.png');
    &:hover.images{
      background-image: url('~@/assets/images/items/hoverImage.png');
    }
}
.btn-area {
  position: relative;
  transition: .4s;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  &.default {
    min-height: 100px;
    min-width: 100px;
    background-color: #fff;
    border-radius: 10px;
    border: 2.5px dashed #1d1d1d;
    box-shadow: 0 0 0 2px #fff;
    background-position: center center;
    background-size: auto 90%;
    background-repeat: no-repeat;
  }
}
@media screen and (max-width: 991px) {
  .flex-row {
    .btn-area {
      width: 50%;
    }
  }
}
.btn-link {
  transition: .4s;
}

.image-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    transition: .5s;
    max-width: 100%;
  }
  .normal-image{
    position: relative;
    z-index: 1;
  }
  .hover-image {
    position: absolute;
    z-index: 1;
    top: 0;
  }
}
.text-area {
  position: absolute;
  z-index: 3;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: var(--text-color);
  font-size: clamp(10px, 2vw, 16px);
}
.decoImage {
  position: absolute;
  z-index: 2;
  top: 0%;
  right: 0;
  height: 100%;
}
.images:hover .normal-image{
  opacity:0;
}
.tab.checked .images .normal-image{
  opacity:0;
}
.float:hover {
  transform: translateY(-5px);
}
.brightness:hover {
  filter: brightness(calc(calc(100 + var(--images-brightness)) * 1%));
}
.opacity:hover {
  opacity: calc(var(--images-opacity) * 1%);
}
.shadow {
  box-shadow: none !important;
  filter: drop-shadow(3px 3px 5px $shadow-color);
  &:hover {
    filter: drop-shadow(3px 3px 10px $shadow-inset-color);
  }
}
.shadow.brightness:hover {
  filter: drop-shadow(3px 3px 10px $shadow-inset-color) brightness(calc(calc(100 + var(--images-brightness)) * 1%));
}

.zoom:hover {
  .decoImage-hover {
    animation: x1 1s 0s ease both;
    -moz-animation: x1 1s 0s ease both;
    -webkit-animation: x1 1s 0s ease both;
    -ms-animation: x1 1s 0s ease both;
  }
}
@keyframes x1 {
  0% {
      opacity: 1;
      filter: alpha(opacity=100);
      transform: scale3d(1,1,1);
      -moz-transform: scale3d(1,1,1);
      -ms-transform: scale3d(1,1,1);
      -webkit-transform: scale3d(1,1,1);
  }

  100% {
      opacity: 0;
      filter: alpha(opacity=0);
      transform: scale3d(1.5,1.5,1);
      -moz-transform: scale3d(1.5,1.5,1);
      -ms-transform: scale3d(1.5,1.5,1);
      -webkit-transform: scale3d(1.5,1.5,1);
  }
}

@-moz-keyframes x1 {
  0% {
      opacity: 1;
      filter: alpha(opacity=100);
      transform: scale3d(1,1,1);
      -moz-transform: scale3d(1,1,1);
      -ms-transform: scale3d(1,1,1);
      -webkit-transform: scale3d(1,1,1);
  }

  100% {
      opacity: 0;
      filter: alpha(opacity=0);
      transform: scale3d(1.5,1.5,1);
      -moz-transform: scale3d(1.5,1.5,1);
      -ms-transform: scale3d(1.5,1.5,1);
      -webkit-transform: scale3d(1.5,1.5,1);
  }
}

@-webkit-keyframes x1 {
  0% {
      opacity: 1;
      filter: alpha(opacity=100);
      transform: scale3d(1,1,1);
      -moz-transform: scale3d(1,1,1);
      -ms-transform: scale3d(1,1,1);
      -webkit-transform: scale3d(1,1,1);
  }

  100% {
      opacity: 0;
      filter: alpha(opacity=0);
      transform: scale3d(1.5,1.5,1);
      -moz-transform: scale3d(1.5,1.5,1);
      -ms-transform: scale3d(1.5,1.5,1);
      -webkit-transform: scale3d(1.5,1.5,1);
  }
}

@-ms-keyframes x1 {
  0% {
      opacity: 1;
      filter: alpha(opacity=100);
      transform: scale3d(1,1,1);
      -moz-transform: scale3d(1,1,1);
      -ms-transform: scale3d(1,1,1);
      -webkit-transform: scale3d(1,1,1);
  }

  100% {
      opacity: 0;
      filter: alpha(opacity=0);
      transform: scale3d(1.5,1.5,1);
      -moz-transform: scale3d(1.5,1.5,1);
      -ms-transform: scale3d(1.5,1.5,1);
      -webkit-transform: scale3d(1.5,1.5,1);
  }
}
</style>
